import React from 'react';
import ReactDOM from 'react-dom';
import AutocompleteComponent from './autocompleteComponent';
import { ChatProvider } from './aiservice/aiContext';

document.addEventListener('DOMContentLoaded', () => {
    const headersearch = document.getElementById('headersearch');
    if (headersearch) {
        const placeholder = headersearch.getAttribute('data-placeholder');
        const name = headersearch.getAttribute('data-name');
        const empty = headersearch.getAttribute('data-empty');
        const form = headersearch.querySelector('form');
        const searchfieldValue = headersearch.querySelector('.searchfield__input').getAttribute('value');
        const action = headersearch?.getAttribute('data-action') || '';
        const ainame = headersearch?.getAttribute('data-ainame') || '';
        const aiVisibility = !!(headersearch?.getAttribute('data-aivisibility') === "true") || false;
        const urlParams = new URLSearchParams(window.location.search);
        const excludeExpiredParam = urlParams.get('excludeExpired') ?? 'true';
        if (form) {
            ReactDOM.render(
                <form
                    role="form"
                    action={action}
                    method="get"
                    className="searchfield__container"
                >
                    <input type="hidden" name="tab" value="regulations" />
                    <input type="hidden" name="excludeExpired" value={excludeExpiredParam} />

                    <AutocompleteComponent
                        minChars={2}
                        placeholder={placeholder || ''}
                        endpoint="/api/search/searchhitautocomplete"
                        name={name || 'search'}
                        aiVisibility={aiVisibility}
                        ainame={ainame}
                        queryvalue={searchfieldValue}
                        empty={empty || 'Inget resultat'}
                    />
                </form>,
                headersearch
            );
        }
    }
});